module.exports = __webpack_public_path__ + "static/media/sutros1954Cd03.64a870f8.jpg";